import gql from 'graphql-tag';

export const GetFinanceOverview = gql`
    query GetFinanceOverview(
        $institutionId: SiteId!
        $childStatus: ChildStatusFilter
        $cursor: FinanceOverviewCursor
        $childrenInRooms: [GroupId!]
        $childrenStartedBeforeOrOn: LocalDate
        $planFilter: ChildPlanFilter
        $childStartDateFilter: [ChildStartDateFilter!]
        $search: String
        $childrenBornAfter: LocalDate
        $childrenBornBefore: LocalDate
        $issues: [FinanceOverviewIssuesFilter!]
        $sessionsAndProducts: SessionsAndProductsFilter
        $invoices: InvoicesFilterInputType
        $pageSize: Int
    ) {
        finance {
            overview(
                siteId: $institutionId
                cursor: $cursor
                childStatus: $childStatus
                childrenInRooms: $childrenInRooms
                childrenStartedBeforeOrOn: $childrenStartedBeforeOrOn
                planFilter: $planFilter
                search: $search
                childStartDateFilter: $childStartDateFilter
                childrenBornAfter: $childrenBornAfter
                childrenBornBefore: $childrenBornBefore
                issues: $issues
                sessionsAndProducts: $sessionsAndProducts
                invoices: $invoices
                pageSize: $pageSize
            ) {
                cursor
                isEnabled
                shouldUseNewPowerPage
                paymentsAccountStatus {
                    ... on FinanceOverviewPaymentsAccountStatusCanManageAccountExists {
                        status
                    }
                }
                children {
                    child {
                        id
                        birthday
                        name {
                            fullName
                            firstName
                            middleName
                            lastName
                        }
                        profileImage {
                            url
                        }
                        group {
                            title
                        }
                        startDate
                        endDate
                    }
                    billPayers {
                        billPayer {
                            name
                            billPayerId
                            email
                            phone
                        }
                        share
                        balance
                        billingFrequency
                        paymentMethods {
                            id
                            type
                            active
                            title
                        }
                        automaticPaymentMethodId
                        onAutomaticBilling
                        latestInvoice {
                            invoiceDate
                            total
                            invoiceId
                        }
                        nextInvoice
                        onAutomaticBilling
                    }
                    plans {
                        planId
                        range {
                            from
                            to
                        }
                        pricingGroup {
                            # If empty/null, automatic pricing groups/bands are used
                            title
                            pricingGroupId
                        }
                        # replaces pricingGroup in the case of automatic pricing groups/bands
                        ruleGroupId
                        parts {
                            planPartId
                            order # Only parts with order = 0 can have funding
                            termTimeOnly
                            statistics {
                                sessionMinutesPerWeek
                            }
                            priceModifiers {
                                title
                            }
                            billingScheme {
                                id
                                shortTitle
                                title
                            }
                            attendanceSchedule {
                                id
                                title
                                fullYear
                            }
                            billingProfile {
                                billingProfileId
                                title
                                annualization {
                                    weeksOfCare
                                    invoices
                                }
                            }
                            funding {
                                method # ASSISTED, MANUAL or MANUAL_BY_RATE
                                time {
                                    ... on PlanFundingTimeHours {
                                        hours
                                    }
                                    ... on PlanFundingTimeMinutes {
                                        minutes
                                    }
                                }
                                ... on PlanFundingManual {
                                    amount
                                }
                                ... on PlanFundingManualByRate {
                                    rate
                                }
                            }
                            bookings {
                                planId
                                planPartId
                                ... on PlanSessionBooking {
                                    sessionAvailability {
                                        session {
                                            sessionId
                                            pricing {
                                                price
                                                pricingGroupId
                                            }
                                            fundable
                                            title # Name of the session
                                            type # StandaloneSession or PackageSession
                                        }
                                        day
                                    }
                                    timeRange {
                                        from
                                        to
                                    }
                                }
                                ... on PlanProductBooking {
                                    amount
                                    productAvailability {
                                        product {
                                            productId
                                            title # Name of the product/extra charge
                                            pricing {
                                                pricingGroupId
                                                price
                                            }
                                        }
                                        day
                                    }
                                }
                            }
                            priceModifiers {
                                amount
                                percent
                                order
                                showOnInvoice
                                title
                                ... on PlanPriceModifierDiscount {
                                    discountPresetId
                                    period
                                }
                                ... on PlanPriceModifierSurcharge {
                                    period
                                }
                            }
                        }
                    }
                    nextInvoice {
                        frequencyAbbreviation
                        total
                        onAutomaticBilling
                        dateFormatted
                        invoicingDate
                        futurePlan {
                            range {
                                from
                            }
                        }
                        timeRange {
                            from
                            to
                        }
                    }
                }
            }
        }
    }
`;

export const GetFinanceOverviewAccess = gql`
    query GetFinanceOverviewAccess($siteId: SiteId!) {
        finance {
            financeOverviewVersioned {
                v1 {
                    access(siteId: $siteId) {
                        isFinanceOverviewEnabled
                        shouldUseBillingHub
                    }
                }
            }
        }
    }
`;
